/**
 * Central place for onboarding step names to be passed to/from the API.
 */
export enum OnboardingStep {
  Completed = 'completed',
  Initial = 'initial',
}
